<template>
  <div>
    <nav class="main-header navbar navbar-expand navbar-white navbar-light no-print">
      <!-- Left navbar links -->
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
        </li>
        <li class="nav-item d-none d-sm-block d-md-block d-lg-block d-xl-block">
          <a href="#" class="nav-link">
            <h4>Borrower Registration System</h4>
          </a>
        </li>

        <li class="nav-item d-block d-sm-none">
          <a href="#" class="nav-link">
            <h4>BRS</h4>
          </a>
        </li>
      </ul>

      <!-- Right navbar links -->
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <a class="nav-link pointer" @click="logout">
            <i class="fas fa-sign-out-alt"></i>
            Logout
          </a>
        </li>

      </ul>
    </nav>
  </div>

</template>
<script>
  export default {

    methods: {
      logout() {
        axios.post('/logout').then(response => {
          window.location.href = "/pcci";
        }).catch(error => {

        });
      },
    },

    mounted() {
      // console.log('Success');
    },
  }
</script>
